// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultBandMappingPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultBandMappingPaginationFilter = {
	$skip: defaultBandMappingPagination.$skip,
	$limit: defaultBandMappingPagination.$limit,
};

export default {
	state: {
		bandMapping: [],
		trustBands: [],
		bandMappingPagination: defaultBandMappingPagination,
		bandMappingPaginationFilter: defaultBandMappingPaginationFilter,
	},
	getters: {
		setBandMappingPage: (state) => {
			const { $limit, $skip } = state.bandMappingPagination;
			return $skip / $limit + 1;
		},
		
	},
	mutations: {
		SET_BAND_MAPPING: (state, data) => { state.bandMapping = data; },
		SET_BAND_MAPPING_PAGINATION: (state, data) => { state.bandMappingPagination = { ...state.bandMappingPagination, ...data }; },
		SET_BAND_MAPPING_PAGINATION_FILTER: (state, data) => { state.bandMappingPaginationFilter = { ...state.bandMappingPaginationFilter, ...data }; },
		SET_TRUST_BAND_MAPPING: (state, data) => { state.trustBands = data; },
	},
	actions: {
		setbandMappingListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.bandMappingPagination.$limit;
			commit('SET_BAND_MAPPING_PAGINATION', { $skip });
			commit('SET_BAND_MAPPING_PAGINATION_FILTER', { $skip });
		},

		getBandMapping: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').find({
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['bands', 'jobTitle'],
					...filter,
				},
			});
			commit('SET_BAND_MAPPING', results.data);
			commit('SET_BAND_MAPPING_PAGINATION', { total: results.total });
			return results.data;
		},
		createBandMapping: async({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updateBandMapping: async({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').patch(data.id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		deleteBandMapping: async ({ rootGetters }, id) => {
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').remove(id, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getBandMappingById: async({ rootGetters }, id) => {
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').get(id, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});

			return results;
		},
		getAllBandMappingForTrust: async({ rootGetters, commit }, filter) => {
		
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').find({
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['bands', 'jobTitle'],
					...filter,

				},
			});
			
			commit('SET_BAND_MAPPING', results.data);
			commit('SET_BAND_MAPPING_PAGINATION', { total: results.total });
			
			return results;
		},
		getAllBandMapping: async({ rootGetters }) => {
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').find({
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results.data;
		},
		trustBands: async({ rootGetters, commit, rootState }, filter) => {
			const results = await feathersClient.service('/api/v3/trust-band-types').find({
				query: {
					$role: rootGetters.currentUserRole,
					trustId: rootState?.organizationStore?.currentTrustId,
					fields: ['band', 'optimaMappings'],
					...filter,
				},
			});
			commit('SET_TRUST_BAND_MAPPING', results?.data);
			return results.data;
		},
		// eslint-disable-next-line no-unused-vars
		getOptimaGradesMapping: async({ rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/optima-mappings').find({
				query: {
					$role: rootGetters.currentUserRole,
					// trustId:rootState?.organizationStore?.currentTrustId
					$getGrades: true,
					...filter,
				},
			});
			return results;
		},
		saveUserPostings: async({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/user-esr-numbers').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getUserPostings: async({ rootGetters }, filters) => {
			const results = await feathersClient.service('/api/v3/user-esr-numbers').find( {
				query: {
					$role: rootGetters.currentUserRole,
					$searchStaff:true,
					...filters
				},
			});
			
			return results;
		},
		// eslint-disable-next-line no-unused-vars
		getBandMappingByID: async function({ rootGetters }, id) {
			const results = await feathersClient.service('/api/v3/optima-mappings').find({
				query: {
					$role:rootGetters.currentUserRole,
					// trustId:rootState?.organizationStore?.currentTrustId
					$getBandMappings: true,
					bandId: id,

				},
			});
			return results;
		},
		createOptimaTrustBandMapping: async function ({ rootGetters }, data) {
			const results = await feathersClient.service('/api/v3/optima-mappings').create(data, {
				query: {
					$createBandMapping: true,
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		deleteOptimaTrustBandMapping: async function ({ rootGetters }, data) {
			const results = await feathersClient.service('/api/v3/optima-mappings').remove(null, {
				query: {
					$deleteBandMapping: true,
					$role: rootGetters.currentUserRole,
					...data,
				},
			});
			return results;
		},

	},
};
